import { Serializable } from '@/models/core/serializable';
import { StudentGoodPoint } from '@/models/student/good-point';

// 強み評価
export class StudentGoodPoints implements Serializable<StudentGoodPoints> {
  data: StudentGoodPoint[];

  deserialize(input: any): StudentGoodPoints {
    this.data = input.data.map((d: StudentGoodPoint) => new StudentGoodPoint().deserialize(d));

    return this;
  }
}
